import { API_ENV } from "constants/environment";

function getEndpoints() {
  return {
    token: `https://m2pfccboh1.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    login: `https://tcefcrhsw0.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    stock: `https://pje3oa5qlk.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    store: `https://mp7oaud04i.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    sellinorder: `https://1tp8jv7z61.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    sellincreditlimit: `https://ync8shxizg.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    representative: `https://fpivf618gk.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    financialdocument: `https://mrnk4zey37.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    order: `https://jy1xv1dso8.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    commercialstructure: `https://cfnachfpfe.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    invoice: `https://hh6lxhg458.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    attendance: `https://6xhpqthjil.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    product: `https://1z855c323f.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    log: `https://pmb33967ki.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    adminportal: `https://k7r1eh9a5a.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    adminportalStage: `https://k7r1eh9a5a.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    reportApp: `https://xhnbwpl1ob.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    selloutreport: `https://ajjqoub2e5.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    omnireport: `https://2c204uqqf7.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    notification: `https://vrzi41sgu0.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    urlshortener: `https://rzqe9yf73d.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    configurationIntegration: `https://k7r1eh9a5a.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    storeadditionalinfo: `https://228brgmn5l.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    ordertracking: `https://3etnrnuxzb.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    weave: `https://k03zim9yob.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    denylist: `https://a6fxq5lhy3.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    seta: `https://7f963yqboa.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    conteudo: `https://f99mwi5vci.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    configuracoesOmni: `https://vrqxm4ttj8.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    configuracoesOmniVendaLink: `https://b6vvpr1y4a.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    showcase: `https://ulhr3ql38i.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    showcaseB2B: `https://s8hed1prfh.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    action: `https://48uk60iihc.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    trocas: `https://jy1xv1dso8.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    azureDevops: `https://j9owh4sh5c.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    userAccess: `https://vrqxm4ttj8.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    shipping: `https://2qiyqni09l.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    infraCommerce: `https://0j00h8ns75.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    trocasDevolucoes: `https://wtwkdywbxj.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    goals: `https://iflk74rbah.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    franquias: `https://fuckmwwttf.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    customer: `https://t1yl0ybs37.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    desiredProducts: `https://e0bb1u62h0.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
    addressLookup: `https://n39n4k4emc.execute-api.us-east-1.amazonaws.com/${API_ENV}/v1/`,
  };
}

export default getEndpoints;
